import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/Card';
import { MeetingHistoryItem } from './MeetingHistoryItem';

type SimplifiedMeeting = {
  _id: string;
  schedualedDate?: string;
  status: string;
};

interface MeetingHistoryListProps {
  meetings: SimplifiedMeeting[] | undefined;
  isLoading: boolean;
}

export const MeetingHistoryList = ({
  meetings,
  isLoading,
}: MeetingHistoryListProps) => {
  const { t } = useTranslation('oneOnOne');

  return (
    <Card className="flex-1 bg-white rounded-xl shadow-md border border-gray-200">
      <CardHeader>
        <CardTitle className="text-xl font-semibold text-slate-900">
          {t('meetingHistory')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
              <p className="mt-4 text-sm text-muted-foreground">
                {t('loading')}
              </p>
            </div>
          </div>
        ) : meetings && meetings.length > 0 ? (
          <div className="relative">
            {meetings.map((meeting, index) => (
              <MeetingHistoryItem
                key={meeting._id}
                meetingId={meeting._id}
                schedualedDate={meeting.schedualedDate}
                status={meeting.status}
                isLast={index === meetings.length - 1}
              />
            ))}
          </div>
        ) : (
          <div className="rounded-lg border border-slate-200 bg-slate-50 py-12 text-center">
            <p className="text-muted-foreground">{t('noOneOnOnesFound')}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
